import React from "react";
import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://shadowspeakjournal.com";
export const OG_IMAGE = `${SITE_URL}/og-umbra.jpg`;

export const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Umbra · Shadow Speak Journal",
  url: SITE_URL,
  logo: OG_IMAGE,
  founder: { "@type": "Person", name: "Uncle Danny" },
  sameAs: ["https://www.instagram.com/shadowspeakjournal/"],
  email: "hello@shadowspeakjournal.com",
};

export const faqJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((i) => ({
    "@type": "Question",
    name: i.q,
    acceptedAnswer: { "@type": "Answer", text: i.a },
  })),
});

export function PageMeta({ title, description, path, jsonLd = [], image = OG_IMAGE }) {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Umbra" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {jsonLd.map((obj, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
      ))}
    </Helmet>
  );
}
